<template lang="pug">
    .files-panel
        v-card(
            outlined
            :style="cardStyle"
            @mouseover="hover = true"
            @mouseleave="hover = false"
        ).pl-3.pr-3.pt-4.pb-0
            p.header(
                :style="[this.filesArray[0]?{'transform': 'translateY(-10px) scale(0.75)', 'color': `${textColor}`}: {'color': `${textColor}`}]"
            ) {{label?label:'Dodaj pliki'}}

            loaded-files(
                v-model="filesArray"
            ).pb-3

            add-files.pb-3(
                @upload="files=>uploadFile(files[0])"
            )
                div(
                    v-if="!fileLoaded"
                ).d-flex.align-center
                    v-icon(
                        left
                        style="font-size: 20px"
                    ) add
                    span Dodaj plik
                div(
                    v-if="fileLoaded"
                ).d-flex.align-center
                    v-icon(
                        left
                        style="font-size: 20px"
                    ) cached
                    span Zmień plik

        div.pl-3
            div(
                v-if="validFile"
                style="color: green; font-size: 12px"
            ) Dodano plik!
            div(
                v-if="validFile==false"
                style="color: #b71c1c; font-size: 12px"
            ) {{ errorText }}

</template>

<script>
import AddFiles from "@/components/filesUpload/AddFiles";
import LoadedFiles from "@/components/filesUpload/LoadedFiles";

export default {
    name: "files-panel",
    components: {
        AddFiles,
        LoadedFiles
    },

    data: () => ({
        filesArray: [],
        hover: false,
        cardColor: "rgba(0, 0, 0, 0.42)",
        cardHoverColor: "black",
        textColor: "#676766",
        validFile: null,
        validSize: null,
        validType: null
    }),

    props: {
        value: {
            type: Array,
            required: true
        },
        label: {
            type: String,
            required: false
        }
    },

    computed: {
        fileLoaded() {
            if (this.filesArray[0]) return true;
            else return false;
        },

        cardStyle() {
            if (this.hover) {
                return `border-bottom-color: ${this.cardHoverColor} !important`;
            } else {
                return `border-bottom-color: ${this.cardColor} !important`;
            }
        },

        errorText() {
            if (!this.filesArray.length) {
                return "Dodaj plik";
            } else if (!this.validType) {
                return "Dopuszczalne formaty pliku to PDF, PNG oraz JPEG";
            } else if (!this.validSize) {
                return "Maksymalny rozmiar pliku to 5MB";
            }
        }
    },

    methods: {
        uploadFile(file) {
            if (this.filesArray.length) {
                this.filesArray.pop();
                this.filesArray.push(file);
            } else this.filesArray.push(file);
            this.validate();
        },
        validate() {
            if (this.filesArray[0]) {
                this.validSize = this.filesArray[0].size < 5242880;
                this.validType =
                    this.filesArray[0].type == "image/jpeg" ||
                    this.filesArray[0].type == "image/png" ||
                    this.filesArray[0].type == "application/pdf";

                if (this.validSize && this.validType) {
                    this.validFile = true;
                    this.cardColor = "rgba(0, 0, 0, 0.42)";
                    this.cardHoverColor = "black";
                    this.textColor = "#676766";
                    return true;
                } else {
                    this.validFile = false;
                    this.cardColor = "#b71c1c";
                    this.cardHoverColor = "#b71c1c";
                    this.textColor = "#b71c1c";
                    return false;
                }
            } else {
                this.validFile = false;
                this.cardColor = "#b71c1c";
                this.cardHoverColor = "#b71c1c";
                this.textColor = "#b71c1c";
                return false;
            }
        }
    },

    watch: {
        value: {
            immediate: true,
            deep: true,
            handler(val) {
                this.filesArray = val;
            }
        },

        filesArray: {
            deep: true,
            handler(val) {
                this.$emit("input", val);
            }
        }
    }
};
</script>

<style lang="sass">
.files-panel
    .header
        width: 100%
        transform-origin: left
        transition: .2s ease-in-out all
        margin-bottom: 0px
        line-height: 8px
        margin-top: 7px

        @media( max-width: 600px )
            line-height: initial
    .v-card
        border-bottom-left-radius: 0px !important
        border-bottom-right-radius: 0px !important
        border: none !important
        border-bottom-style: solid !important
        border-bottom-width: 1px !important
        background-color: rgba(0, 0, 0, 0.06) !important
        transition: .2s ease-in-out all

        &:hover
            background-color: rgba(0, 0, 0, 0.12) !important
</style>